import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { CheckboxGroupStateService } from "./checkbox-group-state.service";

@Component({
    selector: "common-checkbox-group",
    templateUrl: "./common-checkbox-group.component.html",
    providers: [
        CommonFieldManagerDirective,
        { provide: FieldStateService, useClass: CheckboxGroupStateService },
        { provide: FIELD_TOKEN, useValue: "commonFormCheckboxes" },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonCheckboxGroupComponent {
    @HostBinding("class.u-display-flex") public isFlex = true;
    @Input() public groupType = "row";
    constructor(public fieldManager: CommonFieldManagerDirective) { }
}
